import React from 'react';

import Pagination from '@components/Pagination';
import Spinner from '@components/Spinner';
import { useSearchResults } from '@hooks';
import { SearchScope } from '@hooks/useSearchResults';
import { search_page_path } from '@routes';
import { PaginationType } from '@utils/backend-api/subscriber_directory';

import SearchArticlesList from './ArticlesList';
import DirectorySearchResults from './DirectorySearchResults';
import SearchHeader from './Header';
import SearchPostsList from './PostsList';
import { SearchPageProps } from './index';

const SearchContent = ({
  articleContent,
  page,
  pageCount,
  query,
  scope,
  title,
  topRelatedEntities,
}: SearchPageProps) => {
  const { data, isLoading } = useSearchResults(page, query, scope);

  if (isLoading) {
    return <Spinner />;
  }

  const isArticleScope = scope === SearchScope.Articles;
  const isForumScope = scope === SearchScope.Forum;
  const isDirectoryScope = scope === SearchScope.Directory;

  const totalPages = isArticleScope ? pageCount : data?.totalPages ?? 1;

  const paginationData: PaginationType = {
    page,
    totalPages: totalPages,
    hasNextPage: page < totalPages,
    nextPage: page + 1,
  };

  return (
    <div className="mx-12">
      <SearchHeader
        query={query}
        scope={scope}
        title={title}
        topRelatedEntities={topRelatedEntities}
      />
      <div className="mt-28">
        {isArticleScope && <SearchArticlesList content={articleContent} />}
        {isForumScope && <SearchPostsList content={data.forum_posts} />}
        {isDirectoryScope && <DirectorySearchResults data={data} />}
      </div>
      {totalPages > 1 && (
        <Pagination
          getPath={(page) => search_page_path({ query, scope, page })}
          paginationData={paginationData}
        />
      )}
    </div>
  );
};

export default SearchContent;
